import map from "../../app/map"
import rootScope from "../../app/rootScope";
import singleclick from "../../app/singleclick";
import picker from "../../app/picker";
import http from "../../app/http";
import format from "../../app/format";
import broadcast from "../../app/broadcast";
import overlays from "../../app/overlays";


/**
 * Clase que maneja los Puntos de Interés (POI).
 * Proporciona funcionalidades para interactuar con POIs, como eventos de mouse, carga de datos y renderizado.
 */
class PoiHandler {
    constructor() {
        this.spotZoom = 0; // Nivel de zoom para enfocar un punto
        this.pluginIdent = "detail"; // Identificador del plugin
        this.popupOffset = [20, -15]; // Desplazamiento del popup
        this.ident = "empty"; // Identificador del manejador de POIs
        this.events = ["onmouseover", "onmouseout"]; // Eventos que se manejarán
        this.iconSizeX = 25; // Ancho del ícono
        this.iconSizeY = 25; // Alto del ícono
        this.iconOffsetX = 12.5; // Desplazamiento horizontal del ícono
        this.iconOffsetY = 12.5; // Desplazamiento vertical del ícono
        this.initProperties(); // Inicializa las propiedades generales
        this.prevZoom = 0; // Nivel de zoom previo
        this.isActive = false; // Indica si el manejador está activo
        this.syncCounter = 0; // Contador de sincronización
        this.emulatedOnHoverId = null; // ID del elemento en hover emulado
        this.latestLoaded = { id: null, data: {} }; // Último POI cargado
        this.controller = false; // Estado del controlador
    }
    /**
     * Inicializa las propiedades generales del manejador de POIs.
     */
    initProperties() {
        const mazZoom = map.getMaxZoom();
        this.generalOptions = {
            pane: "markerPane", // Pane del mapa para los marcadores
            minZoom: 4, // Nivel mínimo de zoom
            maxZoom: mazZoom, // Nivel máximo de zoom
            updateWhenIdle: true, // Actualizar solo cuando el mapa esté inactivo
            updateWhenZooming: false, // No actualizar durante el zoom
            keepBuffer: rootScope.isMobileOrTablet ? 1 : 2, // Tamaño del buffer según el dispositivo
            className: "viewer-pois pois-" + this.ident + " leaflet-zoom-hide" // Clase CSS para los POIs
        };
        this.popupClassName = "leaflet-empty-popup rounded-box ".concat(this.ident, "-popup");
        this.tileUrl = "/pois/v2/".concat(this.ident, "/tiles/{z}/{x}/{y}");
    }
    /**
     * Activa el manejador de POIs, habilitando su funcionalidad.
     * Agrega los listeners de eventos y componentes necesarios.
     */
    activate() {
        this.isActive = true;
        map.addLayer(this.layer); // Agrega la capa de POIs al mapa

        if (!this.layer._container) {
            throw new Error("Cannot activate POI layer ".concat(this.ident, ". Property _container is missing in layer."));
        }

        for (const o of this.events) {
            this.layer._container[o] = this.event.bind(this, o); // Asocia los eventos al contenedor de la capa
        }

        this.formatDir = format.getDirFunction(); // Obtiene la función de formato de dirección

        singleclick.on("poi-".concat(this.ident), this.onclick, this); // Agrega el listener para el evento de clic
        map.on("zoomend", this.onmouseout, this); // Agrega el listener para el evento de fin de zoom

        // if (rootScope.isMobileOrTablet) {
        //     picker.emitter.on("getPOIsAtXY", this.emulateOnMouseOver, this); // Listener para obtener POIs en dispositivos móviles
        //     picker.emitter.on("pickerClosed", this.cleanEmulatedHoverPOI, this); // Limpia el hover emulado
        //     // picker.emitter.on("rqstOpenPOIdetail", this.openPlugin, this); // Abre el detalle del POI
        // }
    }
    /**
     * Desactiva el manejador de POIs, deshabilitando su funcionalidad.
     * Elimina los listeners de eventos y limpia los recursos.
     */
    deactivate() {
        this.isActive = false;
        this.lastUrl = null;
        singleclick.off(`poi-${this.ident}`, this.onclick, this); // Elimina el listener de clic
        map.removeLayer(this.layer); // Elimina la capa de POIs del mapa
        map.off("zoomend", this.onmouseout, this); // Elimina el listener de fin de zoom
        this.onmouseout(); // Limpia el estado de mouse-out

        // if (rootScope.isMobileOrTablet) {
        //     picker.emitter.off("getPOIsAtXY", this.emulateOnMouseOver, this); // Elimina el listener de hover emulado
        //     picker.emitter.off("pickerClosed", this.cleanEmulatedHoverPOI, this); // Elimina el listener de cierre del picker
        //     picker.emitter.off("rqstOpenPOIdetail", this.openPlugin, this); // Elimina el listener de apertura de detalle
        // }
    }
    /**
     * Limpia el estado del hover emulado.
     */
    cleanEmulatedHoverPOI() {
        picker.emitter.emit("POIclose"); // Emite el evento de cierre de POI
        this.emulatedOnHoverId = null; // Resetea el ID del hover emulado
        if (this.emulatedOnHoverEl) {
            this.emulatedOnHoverEl.classList.remove("emulated-hover"); // Elimina la clase de hover
        }
    }
    // /**
    //  * Emula un evento de mouse-over para un POI en dispositivos móviles.
    //  * @param {Object} event - El objeto del evento.
    //  * @param {Object} coords - Las coordenadas del evento.
    //  */
    // emulateOnMouseOver(event, coords) {
    //     const tileInfo = this.layer.searchTilesForXY.call(this.layer, event, coords, this.iconSizeX, this.iconSizeY, this.iconOffsetX, this.iconOffsetY);
    //     if (tileInfo) {
    //         const { tileEl, id } = tileInfo;
    //         if (id === this.emulatedOnHoverId) return;
    //
    //         this.cleanEmulatedHoverPOI();
    //         const element = tileEl.querySelector(`div[data-id="${id}"]`);
    //         if (element && element.dataset) {
    //             this.emulatedOnHoverId = id;
    //             this.emulatedOnHoverEl = element;
    //             element.classList.add("emulated-hover");
    //             this.onmouseover(String(id), +element.dataset.lat, +element.dataset.lon, element.dataset);
    //         }
    //     } else if (this.emulatedOnHoverId) {
    //         this.cleanEmulatedHoverPOI();
    //     }
    // }
    /**
     * Maneja eventos genéricos para el manejador de POIs.
     * @param {string} eventType - El tipo de evento (e.g., "onmouseover", "onmouseout").
     * @param {Object} eventObject - El objeto del evento.
     */
    event(eventType, eventObject) {
        const dataset = (eventObject?.target instanceof HTMLElement) && eventObject.target.dataset;
        if (dataset) {
            switch (eventType) {
                case "onmouseout":
                    this.onmouseout();
                    break;
                case "onmouseover":
                    if (!rootScope.isMobileOrTablet && dataset.id !== undefined && dataset.lat !== undefined && dataset.lon !== undefined) {
                        this.onmouseover(dataset.id, +dataset.lat, +dataset.lon, dataset, eventObject);
                    }
                    break;
            }
        }
        if (eventObject) {
            eventObject.stopPropagation(); // Detiene la propagación del evento
        }
    }
    /**
     * Maneja el evento de mouse-over para un Punto de Interés (POI).
     * Realiza una solicitud HTTP para obtener detalles del POI y los procesa.
     *
     * @param {string} id - El identificador único del POI.
     * @param {number} lat - La latitud del POI.
     * @param {number} lon - La longitud del POI.
     * @param {Object} dataset - El conjunto de datos asociado al POI.
     * @param {Object} event - El objeto del evento (opcional).
     */
    onmouseover(id, lat, lon, dataset, event) {
        if (id) {
            this.requiredID = id; // Almacena el ID del POI requerido
            const latLng = L.latLng(lat, lon); // Crea un objeto de coordenadas LatLng
            const url = `${rootScope.poisURL}weather/details/${id}.json`; // Construye la URL para la solicitud HTTP

            // Realiza una solicitud HTTP para obtener los detalles del POI
            this.loadingPromise = http.get(url).then((response) => this.onmouseLoaded(id, latLng, response));
        }
    }
    /**
     * Maneja el evento de clic en un Punto de Interés (POI).
     * Verifica si los datos del evento contienen un POI válido, realiza una solicitud HTTP
     * para obtener detalles del POI y emite un evento con los datos obtenidos.
     *
     * @param {Object} event - El objeto del evento que contiene los datos del POI.
     * @param {Object} event.dataset - El conjunto de datos asociados al POI.
     * @param {string} event.dataset.id - El identificador único del POI.
     * @param {number} event.dataset.lat - La latitud del POI.
     * @param {number} event.dataset.lon - La longitud del POI.
     */
    onclick(event) {
        const { id, lat, lon } = event.dataset;
        if (id !== undefined && lat !== undefined && lon !== undefined) {
            // Si no hay un controlador, renderiza la ventana de observación.
            if (!this.controller) {
                this.renderObsWindow();
            }

            const latLng = L.latLng(lat, lon); // Crea un objeto de coordenadas LatLng.
            const url = `${rootScope.poisURL}weather/details/${id}.json`; // Construye la URL para la solicitud HTTP.

            // Realiza una solicitud HTTP para obtener los detalles del POI.
            http.get(url).then((response) => {
                if (response.status === 200) {
                    const data = this.prepareData(response.data); // Prepara los datos obtenidos.

                    // Emite un evento con los detalles del POI.
                    broadcast.emit("obsDetail", response.data);
                }
            });
        }
    }
    /**
     * Prepara los datos proporcionados para su posterior procesamiento.
     * Actualmente, esta función devuelve los datos sin modificaciones.
     *
     * @param {Object} data - Los datos que se van a preparar.
     * @returns {Object} Los datos preparados.
     */
    prepareData(data) {
        return data;
    }
    // openPlugin(o) {
    //     const t = this.latestLoaded.id === o.id && this.latestLoaded.data.name || undefined;
    //     const i = {
    //         id: o.id,
    //         lat: o.lat,
    //         lon: o.lon,
    //         source: "poi-icon",
    //         poiType: this.ident,
    //         name: t
    //     };
    //     if (this.pluginIdent) {
    //         broadcast.emit("rqstOpen", this.pluginIdent, i);
    //     }
    // }
    /**
     * Maneja el evento de mouse-out para un Punto de Interés (POI).
     * Limpia el identificador requerido y elimina el popup abierto del mapa.
     */
    onmouseout() {
        this.requiredID = null; // Resetea el ID requerido
        if (this.openedPopup) {
            map.removeLayer(this.openedPopup); // Elimina el popup del mapa
            this.openedPopup = null; // Resetea la referencia al popup
        }
    }

    /**
     * Maneja la carga de datos de un POI tras una solicitud HTTP.
     * Verifica si los datos corresponden al POI requerido, actualiza el estado
     * y renderiza un popup con la información del POI.
     *
     * @param {string} id - El identificador único del POI.
     * @param {Object} latLng - Las coordenadas del POI como objeto LatLng.
     * @param {Object} response - La respuesta de la solicitud HTTP.
     * @param {Object} response.data - Los datos del POI obtenidos de la solicitud.
     */
    onmouseLoaded(id, latLng, response) {
        const { data } = response;
        if (data && this.requiredID === id) {
            this.requiredID = null; // Resetea el ID requerido
            this.loadingPromise = null; // Limpia la promesa de carga
            this.latestLoaded = {
                id: id, // Almacena el ID del POI cargado
                data: data // Almacena los datos del POI cargado
            };
            if (data.lat && data.lon) {
                latLng = L.latLng(data.lat, data.lon); // Actualiza las coordenadas si están disponibles
            }
            const popupContent = this.renderPopup(id, data); // Genera el contenido del popup
            if (popupContent) {
                if (rootScope.isMobileOrTablet) {
                    // Emite un evento con los datos del POI en dispositivos móviles
                    picker.emitter.emit("POIloaded", {
                        id: id,
                        type: this.ident,
                        lat: data.lat,
                        lon: data.lon,
                        html: popupContent
                    });
                } else {
                    // Muestra un popup en el mapa para dispositivos no móviles
                    this.openedPopup = L.popup({
                        className: this.popupClassName,
                        offset: this.popupOffset,
                        closeButton: false,
                        minWidth: 200,
                        autoPan: false
                    }).setLatLng(latLng).setContent(popupContent).openOn(map);
                }
            }
        }
    }
    /**
     * Actualiza un elemento HTML con un valor numérico, aplicando estilos y datos
     * según el tipo de superposición (overlay) configurado.
     *
     * @param {HTMLElement} element - El elemento HTML que se actualizará.
     * @param {number} value - El valor numérico que se usará para actualizar el elemento.
     */
    updateElementFromNumber(element, value) {
        // console.info(overlays[this.ovrIdent])
        let displayValue;
        switch (this.ovrIdent) {
            case "aqimet":
            case "aqiusa":
                displayValue = value; // Asigna directamente el valor.
                break;
            case "aqieu":
                displayValue = ""; // No asigna ningún valor.
                break;
            case "clouds":
            case "mclouds":
            case "hclouds":
            case "lclouds":
            case "rh":
                displayValue = parseInt(value) + "%"; // Convierte el valor a porcentaje.
                break;
            case "temp2m":
            case "dewpoint":
                // Convierte el valor a grados utilizando la función de conversión del overlay.
                displayValue = overlays[this.ovrIdent].convertNumber.call(this.overlay.m, value) + "°";
                break;
            default:
                // Usa la función de conversión genérica del overlay.
                displayValue = overlays[this.ovrIdent].convertNumber(value);
        }
        // Aplica un color de fondo basado en el valor y actualiza el dataset del elemento.
        element.style.backgroundColor = this.overlay.c.colorDark(value, 20);
        element.dataset.value = displayValue;
    }
    // renderPopularity(popularity) {
    //     if (typeof popularity !== "number") {
    //         return "";
    //     }
    //     const icons = [0, 1, 2, 3, 4].map(level => popularity <= level ? "u" : "o").join("");
    //     return `<p>Popularity: <span class="popularity iconfont">${icons}</span></p>`;
    // }
    /**
     * Redibuja la capa de POIs si se fuerza el redibujado.
     * Verifica si la capa existe y, en caso afirmativo, reinicia su estado.
     *
     * @param {boolean} forceRedraw - Indica si se debe forzar el redibujado de la capa.
     */
    redraw(forceRedraw) {
        if (forceRedraw && this.layer) {
            this.layer._reset();
        }
    }
    // getIconHtml(o, t) {}
}


export default PoiHandler;
